module.exports = __webpack_public_path__ + "static/media/background-gradation-bottom-Desktop.3783242b.png";